import { render, staticRenderFns } from "./NinVerification.vue?vue&type=template&id=402af6e4&scoped=true"
import script from "./NinVerification.vue?vue&type=script&lang=js"
export * from "./NinVerification.vue?vue&type=script&lang=js"
import style0 from "./NinVerification.vue?vue&type=style&index=0&id=402af6e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402af6e4",
  null
  
)

export default component.exports